import React, { useEffect, useState } from "react";
import '../scss/task.scss';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { editPurchaseOrder, getProject, getProjectList, getPurchaseOrder, savePurchaseOrder, getProjectSummary } from "../../../actions/project-management.action";
import { resolveProjectType } from "../utils/resolve-project-type";
import { getVendorList } from "../../../actions/vendor-management.action";
import { warningSnackBar, successSnackBar } from "../../../actions/common.action";
import { PROJECT_MANAGEMENT } from "../../../constants/route-paths";
import CreatePOComponent from "../../../components/po/create";
import { bindActionCreators } from "redux";
import { getGlobalSetting } from "../../../actions/global-setting.action";
import { getCustomerSiteAddress } from "../../../actions/customer-management.action";
import { getInventoryLists } from "../../../actions/inventory.action";
import idx from "idx";

const CreatePurchaseOrder = (props) => {
  const { projectId, poId } = useParams();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [projectType, setProjectType] = useState("");
  const [projectName, setProjectName] = useState("");
  const projectState = useSelector(state => state.project);

  useEffect(() => {
    fetchData();
  }, [projectId]);

  const fetchData = async () => {
    if (projectId) {
      const projectSummary = await props.getProjectSummary(projectId);
      const resolvedType = resolveProjectType(searchParams.get("project-type") || projectSummary.projectType, projectState);
      setProjectType(resolvedType);
      setProjectName(idx(projectSummary, _ => _.name) || '');
    }
  };

  const viewPoList = () => navigate(`/${PROJECT_MANAGEMENT}/purchase-order/${projectId}`);
  const viewProject = () => navigate(`/projects/view/${projectId}`);
  const viewProjectList = () => {
    let type = resolveProjectType(searchParams.get("project-type") || projectType, projectState);
    navigate(`/projects?project-type=${type}`);
  }

  return (
    <>
      <CreatePOComponent
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item onClick={viewProjectList}>PROJECTS</Breadcrumb.Item>
            <Breadcrumb.Item onClick={viewProject}>{projectName}</Breadcrumb.Item>
            <Breadcrumb.Item onClick={viewPoList}>PO LIST</Breadcrumb.Item>
            <Breadcrumb.Item active>{poId ? 'Edit Purchase Order' : 'Create Purchase Order'}</Breadcrumb.Item>
          </Breadcrumb>
        }
        projectId={projectId}
        cancelHandler={viewPoList}
        warningSnackBar={props.warningSnackBar}
        successSnackBar={props.successSnackBar}
        getProject={props.getProject}
        getProjectList={props.getProjectList}
        savePurchaseOrder={props.savePurchaseOrder}
        editPurchaseOrder={props.editPurchaseOrder}
        getVendorList={props.getVendorList}
        getPurchaseOrder={props.getPurchaseOrder}
        getGlobalSetting={props.getGlobalSetting}
        getCustomerSiteAddress={props.getCustomerSiteAddress}
        getInventoryItems={props.getInventoryLists}
      />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  getProjectList: bindActionCreators(getProjectList, dispatch),
  savePurchaseOrder: bindActionCreators(savePurchaseOrder, dispatch),
  editPurchaseOrder: bindActionCreators(editPurchaseOrder, dispatch),
  getVendorList: bindActionCreators(getVendorList, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
  getPurchaseOrder: bindActionCreators(getPurchaseOrder, dispatch),
  getGlobalSetting: bindActionCreators(getGlobalSetting, dispatch),
  getCustomerSiteAddress: bindActionCreators(getCustomerSiteAddress, dispatch),
  getInventoryLists: bindActionCreators(getInventoryLists, dispatch),
  getProjectSummary: bindActionCreators(getProjectSummary, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePurchaseOrder);